import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { useCommonDataContext } from '../../context/CommonDataProvider';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({ open, setOpen, formData, fetchData, handleFetchFailure, handleFetchSuccess}) {

  console.log('formData from full screen', formData);
  const navigate = useNavigate();

  const { sortedProductData } = useCommonDataContext();


  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    setSelectedIds(formData.products);
    console.log('selected ids from FullScreenDialog', selectedIds);
  }, [formData.products]);

  const handleCheckboxChange = (id) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.some(product => product.productId === id)
        ? prevSelectedIds.filter((product) => product.productId !== id)
        : [...prevSelectedIds, { productId: id }]
    );
  };

  const groupProductsByLetter = (products) => {
    return products.reduce((acc, product) => {
      const firstLetter = product.brandName[0].toUpperCase();
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(product);
      return acc;
    }, {});
  };
  const groupedProducts = groupProductsByLetter(sortedProductData);



  const handleSubmit = async () => {

    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    
    try {
      console.log('selected ids',selectedIds)
      console.log('fdsfasdf',formData._id)
      const response2 = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${formData._id}`, {
        method: 'PUT', // or 'POST' if applicable
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          "products": selectedIds
        })});

      if (response2.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
      if (!response2.ok) {
        handleFetchFailure();
        throw new Error('Network response was not ok');
       
      }
      // console.log('Form data submitted successfully');
      fetchData();
      handleFetchSuccess();
      // fetchStockistStatus({companyId:data.companyId});
      // setEditMode(false);
    } catch (error) {
      console.error('Error submitting form data:', error);
      handleFetchFailure();
    }
  };

  const handleClose = () => {
    // handleSubmit();
    setOpen(false);
  };

  const handleSave = () => {
    handleSubmit();
    handleClose();
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' ,backgroundColor: 'var(--color-sidebar)', color:'white'}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              sx={{color:'var(--color-text-sidebar)'}}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave} sx={{backgroundColor:'var(--color-button)', '&:hover': {
              backgroundColor: 'var(--color-button-hover)'}, borderRadius:8, fontFamily:'Titillium Web ,sans-serif'}}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <div className="p-4 grid grid-cols-1 gap-4">
        {Object.keys(groupedProducts).sort().map(letter => (
        <div key={letter} className="col-span-1">
          <h2 className="text-lg font-bold text-gray-700">{letter}</h2>
          <div className="grid grid-cols-5 gap-4">
          {groupedProducts[letter].map((item) => (
            <div key={item._id} className={`col-span-1 shadow-md rounded-lg p-4 flex items-center hover:bg-skin-button ${selectedIds.some(product => product.productId === item._id) ? 'bg-skin-button' : 'bg-skin-fill'}`}>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={selectedIds.some(product => product.productId === item._id)}
                  onChange={() => handleCheckboxChange(item._id)}
                  className='form-checkbox h-5 w-5 '
                  
                />
                <span className={`text-skin-base font-custom`}>{item.brandName}</span>
              </label>
            </div>
          ))}
        </div>
        </div>
      ))}
    </div>
      </Dialog>
    </React.Fragment>
  );
}
